import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import BreadcrumbProp from '../../commonComponents/pageLayout/breadcrumbProp';
import Breadcrumbs from '../../commonComponents/pageLayout/Breadcrumbs';
import WhiteBar from '../../commonComponents/pageLayout/WhiteBar';
import AttributeProp from './propTypes/attributeProp';
import SearchInput from '../../commonComponents/SearchInput';

/**
 * Page sub header, as defined by metronic
 */
export default function ShopSubHeader({
  title,
  breadcrumbs,
  hasWhiteBar,
  filter,
  handleSearchChange,
  query,
  t,
}) {
  const titleClass = cx('m-subheader__title', {
    'm-subheader__title--separator': breadcrumbs.length > 0,
  });

  return (
    <div className="m-subheader">
      <div className="d-flex align-items-center">
        <div className="mr-auto">
          <h3 className={titleClass}>{title}</h3>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <div className="row search-on-market">
          <div className="col-lg-12 d-none d-xl-block search-container-mobile">
            <SearchInput
              id="searchInput"
              handleTextValueChange={handleSearchChange}
              placeholder={t('search.products')}
              buttonText={t('search_button')}
              value={query.search}
              reactToEnterPress
            />
          </div>
        </div>
      </div>
      {hasWhiteBar && <WhiteBar filter={filter} />}
    </div>
  );
}

ShopSubHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(BreadcrumbProp.propType)),
  hasWhiteBar: PropTypes.bool,
  filter: PropTypes.string,
  handleSearchChange: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string,
    maxPrice: PropTypes.number,
    attributes: PropTypes.shape(AttributeProp.propType),
    sort: PropTypes.string,
    search: PropTypes.string,
    productType: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

ShopSubHeader.defaultProps = {
  breadcrumbs: [],
  hasWhiteBar: false,
  filter: null,
};
